import { Label } from '../ui/label';
import { Slider } from '../ui/slider';
import { ZoomIn } from 'lucide-react';
import { ZOOM_CONFIG } from '@/constants/cropper';

interface CropperControlsProps {
  zoom: number;
  onZoomChange: (zoom: number) => void;
}

/**
 * CropperControls Component
 * 
 * Renders the zoom slider control
 */
export function CropperControls({ zoom, onZoomChange }: CropperControlsProps) {
  return (
    <div className="p-4 space-y-4 bg-muted/30">
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label className="text-sm font-medium flex items-center gap-2">
            <ZoomIn className="h-4 w-4" />
            Zoom
          </Label>
          <span className="text-sm text-muted-foreground">
            {Math.round(zoom * 100)}%
          </span>
        </div>
        <Slider
          value={[zoom]}
          onValueChange={([value]) => onZoomChange(value)}
          min={ZOOM_CONFIG.MIN}
          max={ZOOM_CONFIG.MAX}
          step={ZOOM_CONFIG.STEP}
          className="w-full"
        />
      </div>
    </div>
  );
}

